<template lang="html">
  <v-container
    fill-height
    fluid
    grid-list-xl>
    <busie-monthly-calendar class="monthly-calendar"/>
  </v-container>
</template>

<script>
import MonthlyCalendar from '@/components/busie/MonthlyCalendar'

export default {
  components: {
    'busie-monthly-calendar': MonthlyCalendar
  }
}
</script>

<style lang="css" scoped>
</style>
